/**
 * Market-specific copy for the public landing page, keyed by the instance's
 * `default_country` from `/api/v1/partner`. Unknown countries get the default.
 */

export interface Market {
  /** Plan prices are published; false shows "On request" — the partner sets them. */
  publishedPrices: boolean;
}

const DEFAULT: Market = { publishedPrices: true };

const MARKETS: Record<string, Market> = {
  NG: DEFAULT,
  GB: { publishedPrices: false },
};

export function marketFor(country: string | undefined): Market {
  return MARKETS[(country ?? '').toUpperCase()] ?? DEFAULT;
}
